module.exports = __webpack_public_path__ + "img/empty.6e6bd36f.jpg";